import coverImg from "assets/images/v115/cover.webp"

export const v115Config = {
  cover: {
    en: coverImg,
  },
}
